module.exports = __webpack_public_path__ + "img/questionandanswer.5cf8a051.png";